export enum Token {
  AccessToken = "AccessToken",
  RefreshToken = "RefreshToken",
}

export enum Organization {
  Name = "OrganizationName",
  Logo = "OrganizationLogo"
}
